export function createNDJSONStreamWorker(): Worker {
  return new Worker(new URL('./ndjsonStreamWorker.ts', import.meta.url), { type: 'module' } as any);
}
